import * as tslib_1 from "tslib";
import { MatDialog, MatDialogRef } from '@angular/material';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { Maintenance } from '@core/interfaces';
import { DialogEditMaintenanceComponent } from '../../../dialog-edit-maintenance/dialog-maintenances.component';
var PreviousWarrantyDialogComponent = /** @class */ (function () {
    function PreviousWarrantyDialogComponent(data, matDialogRef, matDialog, maintenancesApi) {
        this.data = data;
        this.matDialogRef = matDialogRef;
        this.matDialog = matDialog;
        this.maintenancesApi = maintenancesApi;
        if (!this.data) {
            return;
        }
        this.maintenances = this.data;
    }
    PreviousWarrantyDialogComponent.prototype.continue = function () {
        if (!this.maintenances) {
            this.matDialogRef.close();
            return;
        }
        var selectedMaintenanceId = this.selectedMaintenance ? this.selectedMaintenance.id : null;
        this.matDialogRef.close({ selectedMaintenanceId: selectedMaintenanceId });
    };
    PreviousWarrantyDialogComponent.prototype.openPreviousMaintenance = function (selectedMaintenance) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var maintenance;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.maintenancesApi.searchOne(selectedMaintenance.id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.matDialog.open(DialogEditMaintenanceComponent, {
                            panelClass: 'dialog-edit-maintenance',
                            data: {
                                maintenance: maintenance,
                                isViewMode: false,
                                selectedTabIndex: 0,
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    return PreviousWarrantyDialogComponent;
}());
export { PreviousWarrantyDialogComponent };
